const { getWindowHeight } = require("../utils");

const INCREMENT = 20;

class Scroller {
  constructor() {
    this.currentTime = 0;
  }

  scrollToElm(elm, callback) {
    this.smoothScrollTo(elm.getELM().offsetTop - 100, 200, callback);
  }

  scrollToEnd(offset, callback) {
    this.smoothScrollTo(document.body.scrollHeight - offset, 200, callback);
  }

  smoothScrollTo(to, duration = 200, callback) {
    const element = document.scrollingElement;
    const start = (element && element.scrollTop) || window.pageYOffset,
      change = to - start;

    this.currentTime = Number.MAX_SAFE_INTEGER; // stops other timer
    const _self = this;
    setTimeout(() => {
      _self.currentTime = 0;
      _self.animateScroll(start, change, duration, callback);
    }, INCREMENT * 3);
  }

  animateScroll(start, change, duration, callback) {
    const _self = this;
    this.currentTime += INCREMENT;
    const val = Math.easeInOutQuad(this.currentTime, start, change, duration);
    window.scrollTo(0, val);
    if (_self.currentTime < duration) {
      window.setTimeout(() => {
        _self.animateScroll(start, change, duration, callback);
      }, INCREMENT);
    } else if (callback) {
      callback();
    }
  }
}

const scroller = new Scroller();
module.exports = scroller;
